/*
 * Venn Platform API 1.0.0 Operations for "holdings"
 * Automatically generated file - do not modify!
 */

import type {
  FinancialPerformanceIndicatorsResponse,
  HoldingsBenchmarkCategory,
  HoldingsBreakdownTypeEnum,
  HoldingsDataRequest,
  HoldingsDataResponse,
  HoldingsScopeEnum,
  HoldingsSubject,
  TopHoldingsDataResponse,
} from '../types';
import type { OperationResult } from '../../utils';
import { buildQuery, buildRequestInit, extractError, retryGeneratedFetch } from '../../utils';

/** Get financial performance indicators */
export async function getFinancialPerformanceIndicators(
  proxySetId?: string,
  body?: HoldingsSubject[],
  signal?: AbortSignal,
): Promise<OperationResult<FinancialPerformanceIndicatorsResponse>> {
  const endpoint = `/api/holdings/financial-performance-indicators${buildQuery({ proxySetId })}`;
  const requestInit = buildRequestInit({
    method: 'POST',
    body: JSON.stringify(body),
    headers: { 'Content-Type': 'application/json' },
    signal,
  });
  const response = await retryGeneratedFetch('POST', () => fetch(endpoint, requestInit));
  if (response.status >= 200 && response.status < 400) {
    const content: FinancialPerformanceIndicatorsResponse =
      (await response.json()) as FinancialPerformanceIndicatorsResponse;
    return {
      content,
      status: response.status,
      headers: {},
    };
  }
  throw await extractError(response);
}
/** Get holdings breakdown */
export async function getHoldingsBreakdown(
  body?: Partial<HoldingsDataRequest>,
  signal?: AbortSignal,
): Promise<OperationResult<HoldingsDataResponse>> {
  const endpoint = '/api/holdings';
  const requestInit = buildRequestInit({
    method: 'POST',
    body: JSON.stringify(body),
    headers: { 'Content-Type': 'application/json' },
    signal,
  });
  const response = await retryGeneratedFetch('POST', () => fetch(endpoint, requestInit));
  if (response.status >= 200 && response.status < 400) {
    const content: HoldingsDataResponse = (await response.json()) as HoldingsDataResponse;
    return {
      content,
      status: response.status,
      headers: {},
    };
  }
  throw await extractError(response);
}
/** Get holdings categories */
export async function getHoldingsCategories(
  breakdownType: HoldingsBreakdownTypeEnum,
  scope?: HoldingsScopeEnum,
  signal?: AbortSignal,
): Promise<OperationResult<HoldingsBenchmarkCategory[]>> {
  const endpoint = `/api/holdings/categories/${encodeURIComponent(breakdownType)}${buildQuery({ scope })}`;
  const requestInit = buildRequestInit({ method: 'GET', signal });
  const response = await retryGeneratedFetch('GET', () => fetch(endpoint, requestInit));
  if (response.status >= 200 && response.status < 400) {
    const content: HoldingsBenchmarkCategory[] = (await response.json()) as HoldingsBenchmarkCategory[];
    return {
      content,
      status: response.status,
      headers: {},
    };
  }
  throw await extractError(response);
}
/** Get top holdings */
export async function getTopHoldings(
  proxySetId?: string,
  body?: HoldingsSubject[],
  signal?: AbortSignal,
): Promise<OperationResult<TopHoldingsDataResponse>> {
  const endpoint = `/api/holdings/top${buildQuery({ proxySetId })}`;
  const requestInit = buildRequestInit({
    method: 'POST',
    body: JSON.stringify(body),
    headers: { 'Content-Type': 'application/json' },
    signal,
  });
  const response = await retryGeneratedFetch('POST', () => fetch(endpoint, requestInit));
  if (response.status >= 200 && response.status < 400) {
    const content: TopHoldingsDataResponse = (await response.json()) as TopHoldingsDataResponse;
    return {
      content,
      status: response.status,
      headers: {},
    };
  }
  throw await extractError(response);
}
